"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultLocale = void 0;
var getDefaultLocale = function () {
    // 一些语言的转换
    var languageMapping = {
        'zh-HK': 'zh-TW',
        'ko-kr': 'ko',
        'tr-TR': 'tr',
        'it-CH': 'it',
        'it-IT': 'it',
        'vi-vn': 'vi',
        'pt': 'pt-BR',
        'pt-PT': 'pt-BR',
        'pt-br': 'pt-BR',
        'zh-tw': 'zh-TW',
        'fil-PH': 'en-PH',
        'pt-HK': 'pt-BR', // 2022-11-22 修复pt-HK的问题
    };
    // 多语言平台当前支持的语言编码表
    var locales = [
        'zh-TW',
        'pt-BR',
        'en-PH',
        'pa-PK',
        'zh',
        'en',
        'es',
        'tr',
        'it',
        'fr',
        'ar',
        'th',
        'ru',
        'ja',
        'ko',
        'id',
        'hi',
        'ms',
        'vi',
        'bn',
        'te',
        'mr',
        'ta',
        'ur',
        'kn',
        'gu',
        'pa',
        'ml',
        'bh',
        'raj',
        'ps',
        'sd',
    ];
    var isMatch = false;
    var locale = navigator.language;
    if (languageMapping[locale]) {
        locale = languageMapping[locale];
    }
    if (locales.includes(locale)) {
        isMatch = true;
    }
    else {
        var prefixLang = locale.split('-')[0];
        if (prefixLang && locales.includes(prefixLang)) {
            isMatch = true;
            locale = prefixLang;
        }
    }
    return isMatch ? locale : 'en';
};
exports.getDefaultLocale = getDefaultLocale;
